<template>
  <StaffLayout section="Staff Reset Password">
    <div class="flex flex-col justify-center min-h-600">
      <!-- component -->
      <div
        class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
      >
        <div class="px-8 py-8 rounded-xl">
          <h1 name="login-title" class="mt-2 text-center font-bold text-2xl">
            Reset Password
          </h1>

          <ErrorDisplay
            :label="resetErrorLabel"
            :message="resetError"
            :isVisible="resetError != null"
          />

          <div v-if="resetRequestSuccess" class="bg-green-200 my-6 p-4">
            <h1 class="text-xl font-bold">Password reset successful</h1>
            <p>
              <router-link to="/staff/login">Click here to Login</router-link>
            </p>
          </div>

          <form action="" class="mt-6">
            <div class="my-5 text-sm">
              <BaseInput
                label="New Password"
                id="password"
                v-model="password"
                type="password"
                autocomplete="current-password"
                placeholder="Password"
              />
            </div>
            <div class="my-5 text-sm">
              <BaseInput
                label="Confirm Password"
                id="passwordConfirm"
                v-model="passwordConfirm"
                type="password"
                placeholder="Password"
              />
            </div>
            <button
              id="login_button"
              class="w-full p-3 py-6 max-w-[140px] text-center text-white duration-300 bg-gray-800 rounded hover:bg-black"
              @click.prevent="resetPassword"
            >
              <span>Reset Password</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </StaffLayout>
</template>
<script setup lang="ts">
import { useUserStore } from "../../store/userStore";

const userStore = useUserStore();

const router = useRouter();
const route = useRoute();

let isLoading = ref(false);
let code: string | null = null;
let username: string | null = null;
onMounted(loadData);
onActivated(() => loadData);
async function loadData() {
  console.log("ResetPassword page loaded");

  isLoading.value = true;
  resetRequestSuccess.value = false;

  await router.isReady();

  //Read code param
  let codeParam = route.query["code"];
  if (codeParam) code = Array.isArray(codeParam) ? codeParam[0] : codeParam;

  if (!code || code.length < 100) {
    resetErrorLabel.value = "Invalid link";
    resetError.value =
      "There is an error with your reset link. Please close this tab and click the link in the email again";
  }

  //Read username param
  let usernameParam = route.query["user"];
  if (usernameParam)
    username = Array.isArray(usernameParam) ? usernameParam[0] : usernameParam;

  if (!username || username.length < 5) {
    resetErrorLabel.value = "Invalid link";
    resetError.value =
      "There is an error with your reset link. Please close this tab and click the link in the email again";
  }

  isLoading.value = false;
}

let resetErrorLabel = ref<string | null>(null);
let resetError = ref<string | null>(null);
let password = ref("");
let passwordConfirm = ref("");
let resetRequestSuccess = ref(false);

async function resetPassword() {
  console.log(`Requesting password reset for ${code}`);
  resetRequestSuccess.value = false;
  resetError.value = null;
  resetErrorLabel.value = null;

  if (!password.value || password.value !== passwordConfirm.value) {
    resetErrorLabel.value = "Passwords do not match";
    resetError.value = "Please enter the same password in both boxes";
    return;
  }

  let resultError = await userStore.passwordReset(username, code, password.value);

  if (resultError && resultError.length > 0) {
    resetErrorLabel.value = "Couldn't reset password";
    resetError.value = resultError;
    resetRequestSuccess.value = false;
  } else {
    resetRequestSuccess.value = true;
  }
}
</script>
